import {defaultState} from '../state';

import * as WizardActions from '../../actions/WizardActions';
import * as WizardMXActions from '../../actions/WizardMXActions';
import * as LoanApplicationActions from '../../actions/LoanApplicationActions';
import * as ProfileActions from '../../actions/ProfileActions';
import * as FileTypeConstants from '../../../common/constants/FileTypeConstants';
import {SUMMARY_MX} from '../../constants/LabelConstants';
import {EMPTY_CATALOG} from '../../constants/GlobalConstants';
import * as UIActions from '../../actions/UIActions';
import * as WizardValidationUtils from '../../utils/WizardValidationUtils';
import {
    FieldApplicantSummary,
    HomeApplicantSummaryDTO,
    PersonalApplicantSummaryDTO,
    WorkApplicantSummaryDTO
} from '../../types/mx/creditoReal/epics';
import {
    HomeDataStepViewFieldErrorState,
    PersonalDataStepViewFieldErrorState,
    WorkDataStepViewErrorFieldState
} from '../../types/mx/creditoReal/reducers';
import {Catalog} from '../../../common/types/common';
import * as LoginActions from '../../actions/LoginActions';
import {INCOMES_NTH_SECTION} from '../../../common/constants/FileTypeConstants';
import {MX_VALUES} from '../../constants/MX/WizardInputs';

const loanApplication = (state = defaultState.creditoReal.loanApplication, action) => {

    switch (action.type) {

        case ProfileActions.GOT_PROFILE_INFO_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    email: action.email,
                }
            };
        case WizardActions.CHANGE_FIRST_NAME_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    firstName: action.firstName,
                }
            };
        case WizardActions.CHANGE_SECOND_NAME_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    secondName: action.secondName,
                }
            };
        case WizardActions.CHANGE_LAST_NAME_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    lastName: action.lastName,
                }
            };
        case WizardActions.CHANGE_SECOND_LAST_NAME_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    secondLastName: action.secondLastName,
                }
            };
        case WizardActions.CHANGE_BIRTH_DATE_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    birthDate: action.birthDate,
                }
            };
        case WizardActions.CHANGE_DOC_NUMBER_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    docNumber: action.docNumber
                }
            };
        case WizardActions.CHANGE_CELL_PHONE_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    cellPhone: action.cellPhone
                }
            };
        case WizardActions.CHANGE_EMAIL_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    email: action.email
                }
            };
        case WizardActions.CHANGE_GENDER_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    gender: action.gender
                }
            };
        case WizardActions.CHANGE_CIVIL_STATUS_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    civilStatus: action.civilStatus
                }
            };
        case WizardActions.CHANGE_STUDIES_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    studiesLevel: action.studies
                }
            };
        case WizardActions.CHANGE_ECONOMIC_DEPENDENTS_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    economicDependents: action.economicDependents
                }
            };
        case WizardActions.CHANGE_ALREADY_HAS_VEHICLE_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    alreadyHasVehicle: action.alreadyHasVehicle
                }
            };
        case WizardActions.CHANGE_NATIONALITY_ACTION.name:
            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    nationality: action.nationality,
                }
            };
        case LoanApplicationActions.SET_HIGHEST_STEP_ACTION.name: {
            return {
                ...state,
                highestStep: action.step
            };
        }
        case WizardActions.SET_LOAN_APPLICATION_TOKEN_ACTION.name:
            return {
                ...state,
                token: action.token
            };
        case WizardActions.CHANGE_ACCEPT_TERMS_ACTION.name:
            return {
                ...state,
                acceptTerms: action.acceptTerms
            };
        case WizardActions.CHANGE_RECEIVE_NEWS_PROMOTIONS_ACTION.name:
            return {
                ...state,
                receiveNewsPromotions: action.receiveNewsPromotions
            };
        case WizardMXActions.CLEAN_NIP_MX_ACTION.name:
            return {
                ...state,
                nip: {
                    ...state.nip,
                    identityBureau: ''
                },
            };
        case WizardMXActions.CHANGE_BUREAU_NIP_ACTION.name:
            return {
                ...state,
                nip: {
                    ...state.nip,
                    identityBureau: action.nip,
                },
            };

        case WizardActions.CHANGE_HOME_ADDRESS_ACTION.name:
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    address: action.address
                }
            };

        case WizardActions.CHANGE_HOME_EXT_NUMBER_ACTION.name:
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    extNumber: action.extNumber
                }
            };

        case WizardActions.CHANGE_HOME_INT_NUMBER_ACTION.name:
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    intNumber: action.intNumber
                }
            };

        case WizardActions.CHANGE_HOME_POSTAL_CODE_ACTION.name:
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    postalCode: action.postalCode
                }
            };
        case WizardActions.CHANGE_HOME_PHONE_ACTION.name:
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    phone: action.phone
                }
            };
        case WizardActions.CHANGE_HOUSE_TYPE_ACTION.name:
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    houseType: action.houseType
                }
            };

        case WizardActions.CHANGE_HOME_COLONY_MX_ACTION.name:
            const defaultCatalog = WizardValidationUtils.defaultCatalog;
            const colony = action.colony ? action.colony : defaultCatalog;
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    selectedColony: colony
                }
            };
        case WizardActions.CHANGE_HOME_STATES_ACTION.name: {
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    state: action.state,
                }
            };
        }
        case WizardActions.CHANGE_HOME_CITY_ACTION.name: {
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    city: action.city,
                }
            };
        }
        case WizardActions.CHANGE_HOME_MUNICIPALITY_ACTION.name: {
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    municipality: action.municipality,
                }
            };
        }
        case WizardActions.CHANGE_HOME_COLONIES_ACTION.name: {
            const defaultCatalog = {id: '', value: ''};
            let colony = action.colonies.find(i => i.id === state.applicantHome.selectedColony.id) || defaultCatalog;
            if (action.colonies.length === 1) {
                colony = {id: action.colonies[0].id, value: action.colonies[0].value};
            }
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    selectedColony: colony,
                    colonies: action.colonies
                }
            };
        }
        case LoanApplicationActions.ERROR_GOT_LOCATIONS_ACTION.name: {
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    state: {
                        id: '',
                        value: '',
                    },
                    city: {
                        id: '',
                        value: '',
                    },
                    municipality: {
                        id: '',
                        value: '',
                    },
                    selectedColony: {
                        id: '',
                        value: '',
                    }
                }
            };
        }
        case WizardActions.CHANGE_HOUSEHOLD_TIME_ACTION.name:
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    houseHoldTime: action.houseHoldTime
                }
            };
        case WizardActions.CHANGE_HOUSEHOLD_MEASURE_ACTION.name:
            return {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    houseHoldMeasure: action.houseHoldMeasure
                }
            };
        case WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_NAME_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    workplaceName: action.workplaceName,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_POSITION_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    position: action.position,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_WORKING_SINCE_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    workingSince: action.workingSince,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_BILLING_TYPE_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    billingTypeId: action.billingType.id,
                    taxRegimeId : action.billingType.id === 'TAX'
                        ? state.applicantEmployment.taxRegimeId
                        : defaultState.creditoReal.loanApplication.applicantEmployment.taxRegimeId,
                },
            };

            case WizardActions.CHANGE_EMPLOYMENT_TAX_REGIME_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    taxRegimeId: action.taxRegime.id,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_DOCUMENT_TYPE_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    documentType: action.documentType,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_BUSINESS_TYPE_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    businessType: action.businessType,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_ADDRESS_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    address: action.address,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_EXT_NUMBER_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    extNumber: action.extNumber,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_INT_NUMBER_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    intNumber: action.intNumber,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    postalCode: action.postalCode,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_PHONE_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    workplacePhone: action.workplacePhone,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_COLONY_MX_ACTION.name:
            const employmentColony = action.colony ? action.colony : WizardValidationUtils.defaultCatalog;
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    selectedColony: employmentColony
                }
            };

        case WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_PHONE_EXT_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    workplacePhoneExt: action.workplacePhoneExt,
                },
            };

        case WizardActions.CHANGE_EMPLOYMENT_MONTHLY_INCOMES_ACTION.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    monthlyIncomes: action.monthlyIncomes,
                },
            };
        case WizardActions.CHANGE_EMPLOYMENT_STATES_ACTION.name: {
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    state: action.state,
                }
            };
        }
        case WizardActions.CHANGE_EMPLOYMENT_CITY_ACTION.name: {
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    city: action.city,
                }
            };
        }
        case WizardActions.CHANGE_EMPLOYMENT_MUNICIPALITY_ACTION.name: {
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    municipality: action.municipality,
                }
            };
        }
        case WizardActions.CHANGE_EMPLOYMENT_COLONIES_ACTION.name: {
            const defaultCatalog = {id: '', value: ''};
            const selectedColony: Catalog = state.applicantEmployment.selectedColony;
            const stateColonyId: string = !!selectedColony ? selectedColony.id : '';
            let colony = action.colonies
                .find(i => i.id === stateColonyId) || defaultCatalog;
            if (action.colonies.length === 1) {
                colony = {id: action.colonies[0].id, value: action.colonies[0].value};
            }
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    selectedColony: colony,
                    colonies: action.colonies
                }
            };
        }
        case WizardActions.CHANGE_OTHER_REFERENCES_ACTION.name:
            return {
                ...state,
                otherReferences: action.otherReferences,
            };
        case WizardActions.CHANGE_INCLUDE_INSURANCE_ACTION.name:
            return {
                ...state,
                insurance: {
                    ...state.insurance,
                    includeInsurance: action.includeInsurance,
                }
            };

        case WizardActions.CHANGE_INSURANCE_ACTION.name:
            return {
                ...state,
                insurance: {
                    ...state.insurance,
                    insuranceSelected: action.insuranceSelected
                }
            };

        case WizardActions.CHANGE_INCLUDE_MONTHLY_INCOMES.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    includeMonthlyIncomes: action.includeMonthlyIncomes
                }
            };

        case WizardActions.CHANGE_EMPLOYMENT_TYPES_INCOMES.name:
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    employmentRelationshipTypeId: action.employmentType?.id
                }
            };

        case WizardActions.CHANGE_CREDIT_HISTORY_OPTIONS_ACTION.name:
            return {
                ...state,
                creditHistory: {
                    ...state.creditHistory,
                    bureauOption: action.bureauOption,
                },
            };

        case WizardActions.CHANGE_BUREAU_OPTION_CREDIT_CARD_LAST_DIGITS_ACTION.name:
            return {
                ...state,
                creditHistory: {
                    ...state.creditHistory,
                    bureauOptionCreditCardLastDigits: action.bureauOptionCreditCardLastDigits,
                },
            };

        case WizardActions.UPLOADED_FILES_ACTION.name:
            const defaultDocs = {lastVersion: { documents: []}};
            const filesList = action.files[0];
            const files = filesList && filesList.documentGroups && filesList.documentGroups;

            const identificationFiles = files && files.find(item =>
                item.documentType.id === FileTypeConstants.IDENTIFICATION_TYPE) || defaultDocs;
            const ifeFrontFiles = identificationFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.IFE_FRONT_SECTION);

            const identificationBackFiles = files && files.find(item =>
                item.documentType.id === FileTypeConstants.IDENTIFICATION_BACK_TYPE) || defaultDocs;
            const ifeBackFiles = identificationBackFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.IFE_BACK_SECTION);

            const homeFiles = files && files.find(item =>
                item.documentType.id === FileTypeConstants.HOME_TYPE) || defaultDocs;
            const homeFilesWithSection = homeFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.HOME_SECTION);

            const workFiles = files && files.find(item =>
                item.documentType.id === FileTypeConstants.PROOF_OF_TAX_STATUS_TYPE) || defaultDocs;
            const workFilesWithSection = workFiles.lastVersion.documents.filter(item =>
                item.fileDetail === FileTypeConstants.WORK_SECTION);

            const otherFiles = files && files.find(item =>
                item.documentType.id === FileTypeConstants.OTHER_TYPE) || defaultDocs;
            const otherMonthFiles = []
            for (let i = 0; i < 20; i++) {
                otherMonthFiles.push(otherFiles.lastVersion.documents.filter(item =>
                    item.fileDetail === FileTypeConstants.INCOMES_NTH_SECTION(i + 1)))
            }
            return {
                ...state,
                files: {
                    identification: {
                        ifeFrontFiles,
                        ifeBackFiles
                    },
                    home: {
                        homeFiles: homeFilesWithSection
                    },
                    work: {
                        billingFiles: workFilesWithSection,
                    },
                    other: {
                        otherMonthFiles: otherMonthFiles
                    }
                }
            };

        case WizardMXActions.GOT_LOAN_APPLICATION_SUMMARY_MX_ACTION.name:
            const desiredVehicle = action.loanApplication.desiredVehicle;
            const summary = action.loanApplication.summary;
            const personal = action.loanApplication.personal;
            const home = action.loanApplication.home;
            const employmentData = action.loanApplication.employmentData;
            const insurance = action.loanApplication.insurance;
            const calculator = action.loanApplication.calculator;

            return {
                ...state,
                summary: {
                    desiredVehicle: desiredVehicle ? `${action.loanApplication.desiredVehicle.brand.value}
                    ${action.loanApplication.desiredVehicle.model.value}
                    ${action.loanApplication.desiredVehicle.version.value}
                    ${action.loanApplication.desiredVehicle.year}` : '',
                    price: summary ? summary.price.displayValue : '',
                    downPayment: summary ? summary.downPayment.displayValue : '',
                    state: calculator ? calculator.state.value : '',
                    term: summary ? summary.term : '',
                    amountFinance: summary ? summary.financingAmount.displayValue : '',
                    detailCommission: summary ? summary.commissionAmount.displayValue : '',
                    monthlyPayment: summary ? summary.monthlyAmount.displayValue : '',
                    monthlyInsurance: summary ? summary.insuranceAmount.displayValue : '',
                    completeName: personal ? `${personal.firstName} ${personal.secondName ? personal.secondName : ''}
                        ${personal.lastName} ${personal.secondLastName}` : '',
                    name: personal ? personal.firstName : '',
                    birthDate: personal ? personal.birthDate : '',
                    rfc: personal ? personal.docNumber : '',
                    cellPhone: personal ? personal.cellPhone : '',
                    email: personal ? personal.email : '',
                    homeAddress: home ? home.address : '',
                    homeExtNumber: home ? home.extNumber : '',
                    homeIntNumber: home ? home.intNumber : '',
                    homePostalCode: home ? home.postalCode : '',
                    homeState: home ? home.state.value : '',
                    homeCity: home && home.city ? home.city.value : '',
                    homeMunicipality: home ? home.municipality.value : '',
                    homeColony: home ? home.colony.value : '',
                    homePhone: home ? home.phone : '',
                    houseHoldMeasure: home ? home.houseHoldMeasure : '',
                    houseHoldTime: home ? home.houseHoldTime : '',
                    workplaceName: employmentData ? employmentData.workplaceName : '',
                    workplacePosition: employmentData ? employmentData.position : '',
                    workplaceSince: employmentData ? employmentData.workingSince : '',
                    workplaceAddress: employmentData ? employmentData.address : '',
                    workplaceExtNumber: employmentData ? employmentData.extNumber : '',
                    workplaceIntNumber: employmentData ? employmentData.intNumber : '',
                    workplacePostalCode: employmentData ? employmentData.postalCode : '',
                    workplaceState: employmentData && employmentData.state ? employmentData.state.value : '',
                    workplaceCity: employmentData && employmentData.city ? employmentData.city.value : '',
                    workplaceMunicipality: employmentData && employmentData.municipality ?
                        employmentData.municipality.value : '',
                    workplaceColony: employmentData && employmentData.colony ? employmentData.colony.value : '',
                    workplacePhone: employmentData ? employmentData.workplacePhone : '',
                    workplacePhoneExt: employmentData ? employmentData.workplacePhoneExt : '',
                    workplaceMonthlyIncomes: employmentData && employmentData.monthlyIncomes ?
                        employmentData.monthlyIncomes.displayValue : '',
                    insurancePaymentType: insurance && insurance.includeInsurance ?
                        SUMMARY_MX.INSURANCE_FINANCED : SUMMARY_MX.INSURANCE_CASH,
                    insuranceName: insurance && insurance.insuranceSelected ? insurance.insuranceSelected.target : '',
                    insuranceAmount: insurance && insurance.insuranceSelected ?
                        insurance.insuranceSelected.insuranceAmount.displayValue : '',
                    references: action.loanApplication.references

                }
            };

        case WizardMXActions.GOT_LOAN_APPLICATION_BY_TOKEN.name:

            const references = action.loanApplication.references;
            const highestStep = action.loanApplication.step;
            const token = action.loanApplication.token;

            return {
                ...state,
                highestStep,
                token,
                otherReferences: references
            };

        case WizardMXActions.SAVE_MARKETING_MX_ACTION.name:
            return {
                ...state,
                marketingSource: action.channelSelected
            };
        case WizardMXActions.SET_PERSONAL_DATA_STATE_ACTION.name:
            const personDataFS: FieldApplicantSummary<PersonalApplicantSummaryDTO, PersonalDataStepViewFieldErrorState>
                = action.fieldSummary;
            const personalApplicantSummary: PersonalApplicantSummaryDTO = personDataFS.data;

            return {
                ...state,
                applicantPersonal: {
                    ...state.applicantPersonal,
                    firstName: personalApplicantSummary.firstName,
                    secondName: personalApplicantSummary.secondName,
                    lastName: personalApplicantSummary.lastName,
                    secondLastName: personalApplicantSummary.secondLastName,
                    birthDate: personalApplicantSummary.birthDate,
                    nationality: personalApplicantSummary.nationality ?? EMPTY_CATALOG,
                    docNumber: personalApplicantSummary.docNumber,
                    cellPhone: personalApplicantSummary.cellPhone,
                    email: personalApplicantSummary.email,
                    gender: personalApplicantSummary.gender,
                    civilStatus: personalApplicantSummary.civilStatus,
                    studiesLevel: personalApplicantSummary.studiesLevel,
                    economicDependents: personalApplicantSummary.economicDependents ?? EMPTY_CATALOG,
                    alreadyHasVehicle: MX_VALUES.BOOLEAN_VALUES
                        .find(option => option.value === personalApplicantSummary.alreadyHasVehicle) ?? EMPTY_CATALOG,
                }
            };
        case WizardMXActions.SET_HOME_DATA_STATE_ACTION.name:
            const homeDataFS: FieldApplicantSummary<HomeApplicantSummaryDTO, HomeDataStepViewFieldErrorState>
                = action.fieldSummary;
            const homeApplicantSummary: HomeApplicantSummaryDTO = homeDataFS.data;
            return homeApplicantSummary ? {
                ...state,
                applicantHome: {
                    ...state.applicantHome,
                    address: homeApplicantSummary.address,
                    extNumber: homeApplicantSummary.extNumber,
                    intNumber: homeApplicantSummary.intNumber,
                    postalCode: homeApplicantSummary.postalCode,
                    state: homeApplicantSummary.state,
                    city: homeApplicantSummary.city,
                    municipality: homeApplicantSummary.municipality,
                    colonies: homeApplicantSummary.colonies,
                    selectedColony: homeApplicantSummary.colony,
                    phone: homeApplicantSummary.phone,
                    houseHoldMeasure: homeApplicantSummary.houseHoldMeasure,
                    houseHoldTime: homeApplicantSummary.houseHoldTime,
                    houseType: homeApplicantSummary.houseType,
                }
            } : state;
        case WizardMXActions.SET_EMPLOYMENT_DATA_STATE_ACTION.name:
            const employmentDataFS: FieldApplicantSummary<WorkApplicantSummaryDTO, WorkDataStepViewErrorFieldState>
                = action.fieldSummary;
            const employmentSummary: WorkApplicantSummaryDTO = employmentDataFS.data;
            return {
                ...state,
                applicantEmployment: {
                    ...state.applicantEmployment,
                    workplaceName: employmentSummary.workplaceName,
                    position: employmentSummary.position,
                    workingSince: employmentSummary.workingSince,
                    address: employmentSummary.address,
                    extNumber: employmentSummary.extNumber,
                    intNumber: employmentSummary.intNumber,
                    postalCode: employmentSummary.postalCode,
                    state: employmentSummary.state,
                    city: employmentSummary.city,
                    municipality: employmentSummary.municipality,
                    colonies: employmentSummary.colonies,
                    selectedColony: employmentSummary.colony,
                    workplacePhone: employmentSummary.workplacePhone,
                    workplacePhoneExt: employmentSummary.workplacePhoneExt,
                    includeMonthlyIncomes: employmentSummary.includeMonthlyIncomes,
                    monthlyIncomes: employmentSummary.monthlyIncomes.value,
                    employmentRelationshipTypeId: employmentSummary.employmentRelationshipId,
                    businessType: employmentSummary.employmentBusinessType,
                    documentType: employmentSummary.incomeProof,
                    billingTypeId: employmentSummary.invoiceInfo?.billingTypeId || '',
                    taxRegimeId: employmentSummary.invoiceInfo?.taxRegimeId || '',
                    billingDocumentId: employmentSummary.invoiceInfo?.billingDocumentId || '',
                }
            };

        case WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN.name:
            return {
                ...defaultState.creditoReal.loanApplication,
                applicantPersonal: {
                    ...defaultState.creditoReal.loanApplication.applicantPersonal,
                    email: state.applicantPersonal.email,
                    firstName: state.applicantPersonal.firstName,
                    lastName: state.applicantPersonal.lastName
                }
            };
        case UIActions.CLEAN_STATE_ACTION.name:
        case LoginActions.LOGOUT_SUCCESS_ACTION.name:
            return defaultState.creditoReal.loanApplication;
        default:
            return state;
    }

};

export default loanApplication;
